// Example class
let _this = (module.exports = {
  // Set the dom elements
  dom: {
    body: document.querySelector("body"),
  },

  // Set variables
  vars: {
    flag: false,
  },

  gallery: function () {
    const gallery = document.querySelector(".wp-block-gallery");
    if (!gallery) return;

    const figures = Array.from(gallery.querySelectorAll(".wp-block-image"));
    const total = figures.length;
    const hasMultiple = total > 1;

    if (hasMultiple) {
      const firstClone = figures[0].cloneNode(true);
      const lastClone = figures[total - 1].cloneNode(true);
      gallery.insertBefore(lastClone, figures[0]);
      gallery.appendChild(firstClone);
    }

    const allImages = Array.from(gallery.querySelectorAll(".wp-block-image"));
    const totalWithClones = allImages.length;
    const realSlidesCount = totalWithClones - 2;

    const TRANSITION_DURATION = 500;
    const SWIPE_THRESHOLD = 70;

    let currSlide = hasMultiple ? 1 : 0;
    let startX = 0;
    let startY = 0;
    let isDragging = false;

    const bar = document.createElement("div");
    bar.className = "wp-block-gallery-bar";

    const titleEl = document.createElement("span");
    titleEl.className = "wp-block-gallery-title";

    bar.appendChild(titleEl);

    if (hasMultiple) {
      const controls = document.createElement("div");
      controls.className = "wp-block-gallery-controls";

      const counter = document.createElement("span");
      counter.className = "wp-block-gallery-counter";

      const btnPrev = document.createElement("button");
      btnPrev.className = "wp-block-gallery-btn wp-block-gallery-btn-prev";
      btnPrev.innerHTML = `<svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.707031 6.35352L16.707 6.35352" stroke="white"/><path d="M6.70703 12.3535L0.707032 6.35352L6.70703 0.353516" stroke="white"/></svg>`;

      const btnNext = document.createElement("button");
      btnNext.className = "wp-block-gallery-btn wp-block-gallery-btn-next";
      btnNext.innerHTML = `<svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 6.35352L-4.76837e-07 6.35351" stroke="white"/><path d="M10 0.353515L16 6.35352L10 12.3535" stroke="white"/></svg>`;

      controls.appendChild(btnPrev);
      controls.appendChild(counter);
      controls.appendChild(btnNext);
      bar.appendChild(controls);

      const setTransition = (duration) => {
        allImages.forEach(
          (fig) => (fig.style.transition = `transform ${duration}ms ease-out`),
        );
      };

      const pad = (n) => (n < 10 ? "0" + n : String(n));

      const updateUI = (slideIndex) => {
        let real = slideIndex;
        if (slideIndex === 0) real = realSlidesCount;
        else if (slideIndex === totalWithClones - 1) real = 1;
        counter.textContent = `${pad(real)} / ${pad(realSlidesCount)}`;
        const img = allImages[slideIndex].querySelector("img");
        titleEl.textContent =
          (img && (img.getAttribute("alt") || img.getAttribute("title"))) || "";
      };

      const goToSlide = (slide) => {
        setTransition(TRANSITION_DURATION);
        allImages.forEach((fig, i) => {
          fig.style.transform = `translateX(${100 * (i - slide)}%)`;
        });
        currSlide = slide;
        updateUI(currSlide);

        if (currSlide === totalWithClones - 1) {
          setTimeout(() => {
            setTransition(0);
            allImages.forEach((fig, i) => {
              fig.style.transform = `translateX(${100 * (i - 1)}%)`;
            });
            currSlide = 1;
            updateUI(currSlide);
            setTimeout(() => setTransition(TRANSITION_DURATION), 50);
          }, TRANSITION_DURATION);
        }

        if (currSlide === 0) {
          setTimeout(() => {
            setTransition(0);
            allImages.forEach((fig, i) => {
              fig.style.transform = `translateX(${100 * (i - realSlidesCount)}%)`;
            });
            currSlide = realSlidesCount;
            updateUI(currSlide);
            setTimeout(() => setTransition(TRANSITION_DURATION), 50);
          }, TRANSITION_DURATION);
        }
      };

      const nextSlide = () => goToSlide(currSlide + 1);
      const prevSlide = () => goToSlide(currSlide - 1);

      gallery.addEventListener("mousedown", (e) => {
        if (e.button !== 0) return;
        isDragging = true;
        startX = e.clientX;
        e.preventDefault();
        setTransition(0);
      });

      gallery.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        const diffX = e.clientX - startX;
        allImages.forEach((fig, i) => {
          fig.style.transform = `translateX(${100 * (i - currSlide) + (diffX / gallery.offsetWidth) * 100}%)`;
        });
      });

      gallery.addEventListener("mouseup", (e) => {
        if (!isDragging) return;
        isDragging = false;
        const diffX = e.clientX - startX;
        setTransition(TRANSITION_DURATION);
        if (Math.abs(diffX) >= SWIPE_THRESHOLD) {
          diffX > 0 ? prevSlide() : nextSlide();
        } else {
          goToSlide(currSlide);
        }
      });

      gallery.addEventListener("mouseleave", () => {
        if (!isDragging) return;
        isDragging = false;
        setTransition(TRANSITION_DURATION);
        goToSlide(currSlide);
      });

      gallery.addEventListener(
        "touchstart",
        (e) => {
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          setTransition(0);
        },
        { passive: true },
      );

      gallery.addEventListener(
        "touchmove",
        (e) => {
          const deltaX = e.touches[0].clientX - startX;
          const deltaY = e.touches[0].clientY - startY;
          if (Math.abs(deltaX) > Math.abs(deltaY)) {
            allImages.forEach((fig, i) => {
              fig.style.transform = `translateX(${100 * (i - currSlide) + (deltaX / gallery.offsetWidth) * 100}%)`;
            });
          }
        },
        { passive: true },
      );

      gallery.addEventListener("touchend", (e) => {
        const diffX = e.changedTouches[0].clientX - startX;
        setTransition(TRANSITION_DURATION);
        if (Math.abs(diffX) >= SWIPE_THRESHOLD) {
          diffX > 0 ? prevSlide() : nextSlide();
        } else {
          goToSlide(currSlide);
        }
        startX = 0;
        startY = 0;
      });

      document.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") prevSlide();
        if (e.key === "ArrowRight") nextSlide();
      });

      btnPrev.addEventListener("click", prevSlide);
      btnNext.addEventListener("click", nextSlide);

      setTransition(0);
      allImages.forEach((fig, i) => {
        fig.style.transform = `translateX(${100 * (i - currSlide)}%)`;
      });
      updateUI(currSlide);
      setTimeout(() => setTransition(TRANSITION_DURATION), 50);
    } else {
      const img = figures[0].querySelector("img");
      titleEl.textContent =
        (img && (img.getAttribute("alt") || img.getAttribute("title"))) || "";
    }

    gallery.appendChild(bar);
  },

  /**
   * Init functions
   */
  init: function () {
    this.gallery();
  },
});
